import { Fragment } from 'react';
import type { NextPage } from 'next';
import { fadeInAnimate, slideInDownAnimate } from 'utils/animation';
import NextLink from 'components/reuseable/links/NextLink';
// -------- custom component -------- //
import { Hero1, Hero1Para } from 'components/blocks/hero';
import ContactFooterCombo from 'components/reuseable/ContactFooterCombo';
import { googleanalytics } from 'data/answer-the-public/googleanalytics';
const answerThePublic = googleanalytics;
import Video from 'components/blocks/video/Video';

import SEO from 'components/common/SEO';
import * as All from 'data/keywords';

const details = {
  pageName: 'Google Analytics Agency London',
  categories: 'seo, web design',
  description:
    'SEOptimist Google Analytics Agency London improves your site ranking with a free technical SEO audit and the highest quality conversion rate optimisation services',
  parentDirectories: ''
};

const croPage: NextPage = () => {
  return (
    <>
      {/* ========== SEO META values ========== */}
      <SEO
        title={`${All.GoogleAnalytics[0].title}`}
        description={details.description}
        tag={details.categories}
        urlPT={``}
        urlENPT={``}
        url={`${All.GoogleAnalytics[0].url}/${All.GoogleAnalytics[0].title.toLowerCase().replace(/ /g, '-')}`}
        image={`img/${All.HomeList[0].title.toLowerCase().replace(/ /g, '-')}.jpg`}
        // updated=""
        // published=""
        // modified=""
      />

      {/* ========== heading section ========== */}
      <Fragment>
        <main className="content-wrapper bg-white">
          {/* ========== hero section ========== */}
          <div style={fadeInAnimate('900ms')}>
            <Video
              heading={All.GoogleAnalytics[0].title}
              title1="AI"
              title2="SEO"
              title3=""
              movie="/1.mp4"
              placeholder="1-bg.jpg"
              button="website-test"
              fontsize1={150}
              fontsize2={150}
              body=""
              intro=" helps London companies improve Google ranking with in-depth Google Analytics analysis. If&nbsp;you&nbsp;want to accelerate
              your business online, we are the experts using proprietary technology and AI."
            />
          </div>{' '}
          <section className="wrapper bg-light">
            <div className="container py-5">
              <div className="row">
                <div className="col-md-6 mx-auto">
                  <h2>{All.GoogleAnalytics[0].title}</h2> {/*  Google analytics agency */}
                  <p>
                    In the dynamic and ever-evolving digital landscape, where competition is fierce and algorithms are
                    constantly changing, it is crucial to have a comprehensive understanding of your website's technical
                    performance. This is where SEOptimist, the leading {All.GoogleAnalytics[0].title}, steps in to
                    provide valuable assistance. We specialize in delivering top-notch technical SEO audit services that
                    empower businesses like yours to identify and address potential issues that may be impeding your
                    online visibility and organic rankings.
                  </p>
                  <p>
                    A technical SEO audit is a meticulous examination of your website's underlying technical
                    infrastructure, ensuring that it is optimized for search engine crawlers and user experience. At
                    SEOptimist, we recognize the critical role that technical factors play in the overall success of your
                    online presence. Our team of experts conducts an in-depth analysis of various elements, including
                    website speed, mobile-friendliness, site architecture, crawlability, indexation, and more. By
                    scrutinizing these aspects, we can uncover any technical hindrances that may be preventing search
                    engines from fully understanding and indexing your website.
                  </p>
                  <p>
                    Through our technical SEO audit services, we provide you with actionable insights and
                    recommendations to enhance your website's performance. We identify opportunities for optimization,
                    propose solutions to address technical issues, and prioritize improvements that will have the
                    greatest impact on your organic rankings. By leveraging our expertise and industry best practices,
                    we help you unlock the full potential of your website, ensuring that it is primed for search engine
                    success. As a leading {All.GoogleAnalytics[0].title}, we specialize in harnessing the power of data
                    to drive measurable results for your business.
                  </p>
                </div>
              </div>
            </div>
          </section>
          <div id="website-test"></div>
          <Hero1
            bgcolor="bg-soft-primary mb-20 pt-20"
            title={``}
            lead={``}
            body={[
              <div key={100} className="text-center" id="report">
                <p className="text-center fs-34 mb-0 mx-auto">
                  <strong>
                    GET YOUR FREE <span className="text-fuchsia">TECHNICAL SEO REPORT</span>
                  </strong>
                </p>
                <p className="text-center fs-18 mx-auto">
                  Action the findings from the report or purchase {All.HomeList[8].title}
                </p>
              </div>
            ]}
          />
          <section className="wrapper bg-light">
            <div className="container py-5">
              <div className="row">
                <div className="col-md-6 mx-auto">
                  <h2>{All.GoogleAnalytics[1].title}</h2> {/*  Google analytics consultant */}
                  <p>
                    As a leading {All.GoogleAnalytics[1].title}, SEOptimist is dedicated to harnessing the immense value
                    that this powerful tool brings to businesses seeking a comprehensive understanding of their
                    website's performance. We take great pride in our team of seasoned experts who are not only
                    well-versed in the intricacies of Google Analytics but are also certified professionals in utilizing
                    this robust platform to its fullest potential. What sets us apart and makes us the best Google
                    Analytics consultant is our unwavering commitment to diving deep into your analytics data, analyzing
                    visitor behaviour, conversion rates, and other crucial metrics to unearth valuable insights and
                    identify opportunities for growth and improvement.
                  </p>
                  <p>
                    When you partner with SEOptimist as your trusted {All.GoogleAnalytics[1].title}, you gain access to a
                    wealth of expertise and knowledge that can revolutionize your understanding of your website's
                    performance. Our team of experts understands the nuances of Google Analytics and is adept at
                    leveraging its features and functionalities to extract actionable insights. We delve into your
                    analytics data with a meticulous eye, uncovering trends, patterns, and correlations that provide
                    valuable context to your website's performance.
                  </p>
                  <p>
                    Through our in-depth analysis, we go beyond surface-level metrics and dig deeper into the
                    intricacies of visitor behaviour. We scrutinize user engagement, bounce rates, conversion paths, and
                    other key indicators to gain a holistic understanding of how visitors interact with your website. By
                    identifying areas of improvement and untapped potential, we provide data-driven recommendations and
                    strategies that enable you to optimize your website's performance, enhance user experience, and
                    drive meaningful results.
                  </p>
                  <p>
                    As a {All.GoogleAnalytics[1].title}, our mission is to empower you with the knowledge and insights
                    needed to make informed decisions and achieve your business goals. We go the extra mile to ensure
                    that you not only have access to valuable data but also understand its implications and how it ties
                    into your overall digital strategy. Our team is always available to guide you through the
                    intricacies of Google Analytics, answer your questions, and provide ongoing support to ensure that
                    you maximize the benefits of this powerful tool.
                  </p>
                  <h2>{All.GoogleAnalytics[2].title}</h2> {/*  web analytics consulting */}
                  <p>
                    At SEOptimist, our {All.GoogleAnalytics[2].title} services are designed to be a catalyst for your
                    business success. We understand that every organization has unique goals and aspirations, and our
                    team of {All.GoogleAnalytics[2].title} experts works closely with you to understand your specific
                    business objectives. By gaining a deep understanding of your vision and aligning it with your
                    digital marketing strategies, we can unlock the full potential of your data and provide actionable
                    insights that drive tangible results.
                  </p>
                  <p>
                    Whether your aim is to increase website traffic, boost conversions, enhance user experience, or
                    achieve a combination of these goals, our {All.GoogleAnalytics[2].title} team is here to guide you.
                    We delve into the vast amount of data at your disposal and make sense of the numbers, uncovering
                    hidden trends, patterns, and correlations that hold the key to unlocking growth opportunities. By
                    analyzing the behaviour of your website visitors, identifying conversion bottlenecks, and
                    pinpointing areas for improvement, we empower you to make data-driven decisions that have a
                    significant impact on your digital marketing efforts.
                  </p>
                  <p>
                    Our {All.GoogleAnalytics[2].title} approach goes beyond just providing you with raw data. We believe
                    in translating complex analytics metrics into actionable insights that you can easily understand and
                    implement. Our team of experts excels at distilling complex data into clear and concise
                    recommendations, ensuring that you have a roadmap for success. We guide you through the intricacies
                    of your data, providing you with a comprehensive understanding of the factors influencing your
                    website's performance and offering practical strategies to optimize your digital marketing
                    campaigns.
                  </p>
                  <p>
                    As your trusted {All.GoogleAnalytics[2].title} partner, we are committed to your success. We
                    continuously monitor and analyze your data, keeping a close eye on trends, shifts, and emerging
                    opportunities. Our agile approach enables us to adapt and refine our recommendations in real-time,
                    ensuring that you stay ahead of the curve and maintain a competitive edge in the digital landscape.
                    With our expertise and dedication to delivering exceptional results, we strive to be your go-to
                    resource for web analytics consulting.
                  </p>
                  <h2>{All.GoogleAnalytics[3].title}</h2> {/*  web analytics agency */}
                  <p>
                    In addition to Google Analytics, our expertise extends to a wide range of web analytics tools and
                    platforms. As a dedicated {All.GoogleAnalytics[3].title}, we leverage cutting-edge technologies and
                    industry best practices to gather, analyze, and interpret data from various sources. From tracking
                    user behaviour to monitoring campaign performance, we ensure that you have a comprehensive view of
                    your online ecosystem. SEOptimist is a complete and trustworthy {All.GoogleAnalytics[3].title}.
                  </p>
                  <h2>{All.GoogleAnalytics[4].title}</h2> {/*  Google ads agency London */}
                  <p>
                    At SEOptimist, we pride ourselves on being a leading {All.GoogleAnalytics[4].title}, dedicated to
                    taking your advertising campaigns to new heights of success. We understand the significance of
                    Google Ads as a powerful advertising platform and the impact it can have on driving quality traffic
                    to your website. As a {All.GoogleAnalytics[4].title}-based, we leverage our expertise in web
                    analytics and combine it with the advanced capabilities of Google's advertising platform to deliver
                    exceptional results for our clients.
                  </p>
                  <p>
                    Our team of skilled professionals possesses in-depth knowledge and experience in creating targeted
                    and optimized Google Ads campaigns. We conduct thorough research and analysis to identify the most
                    relevant keywords, demographics, and audience segments for your business. By understanding your
                    target audience and their preferences, we craft compelling ads that capture their attention and
                    drive them to take action. Our focus is not just on increasing traffic, but on attracting
                    high-quality visitors who are more likely to convert into customers.
                  </p>
                  <p>
                    One of the key advantages of partnering with SEOptimist {All.GoogleAnalytics[4].title} is our
                    integration of data from Google Analytics into your campaigns. We believe in the power of
                    data-driven decision-making, and by leveraging insights from Google Analytics, we continually refine
                    and optimize your ads to maximize return on investment (ROI). We analyze performance metrics,
                    monitor conversion rates, and make data-driven adjustments to ensure that your ad spend is optimized
                    and delivering the desired results.
                  </p>
                  <p>
                    At SEOptimist, we are committed to providing the best to our clients. As a{' '}
                    {All.GoogleAnalytics[4].title}, we continually thrive to stay ahead of industry trends and updates.
                    We keep a close eye on the ever-changing digital landscape, ensuring that our strategies and
                    campaigns are aligned with the latest best practices and innovations. Our team undergoes continuous
                    training and stays up-to-date with the latest Google Ads features and tools, enabling us to offer
                    cutting-edge solutions that drive exceptional results for our clients.
                  </p>
                  <h2>{All.GoogleAnalytics[5].title}</h2> {/*  Google ads agency UK */}
                  <p>
                    As your trusted analytics partner, we understand that every business is unique. That's why we offer
                    customized solutions tailored to your specific needs. {''}
                    {All.GoogleAnalytics[5].title} SEOptimist takes the time to understand your goals, target audience,
                    and competitive landscape. We then develop a data-driven strategy that aligns with your business
                    objectives, leveraging the power of Google Analytics and other web analytics tools to optimize your
                    digital presence. Choosing SEOptimist is choosing the best {All.GoogleAnalytics[5].title} based.
                  </p>
                  <h2>{All.GoogleAnalytics[6].title}</h2> {/*  analytics agencies */}
                  <p>
                    In the ever-expanding realm of {All.GoogleAnalytics[6].title}, SEOptimist distinguishes itself with
                    its unwavering commitment to a holistic approach to data-driven decision-making. While many agencies
                    focus solely on surface-level metrics, we delve deep into the wealth of data available to uncover
                    hidden patterns and insights that can truly transform your business. Our team of seasoned experts
                    combines their expertise in SEO, web analytics, and Google Ads to provide you with a comprehensive
                    view of your online performance, empowering you to make informed decisions that drive sustainable
                    growth.
                  </p>
                  <p>
                    What sets us apart from other {All.GoogleAnalytics[6].title} is our dedication to guiding you every
                    step of the way. We understand that navigating the complex world of data analytics can be
                    overwhelming, which is why we strive to be more than just a service provider. Our team takes the
                    time to understand your unique business needs, goals, and challenges, allowing us to tailor our
                    strategies and recommendations specifically to your requirements. We believe in forming a strong
                    partnership with our clients, working collaboratively to unlock the full potential of your
                    e-commerce business.
                  </p>
                  <p>
                    When you choose SEOptimist as your{' '}
                    <NextLink
                      title={All.EcommerceSEO[0].title}
                      href={
                        '/' + All.EcommerceSEO[0].url + '/' + All.EcommerceSEO[0].title.toLowerCase().replace(/ /g, '-')
                      }
                    />
                    , you gain access to a wealth of expertise and knowledge. We have a proven track record of
                    delivering tangible results for our clients, helping them achieve sustainable growth in the
                    ever-evolving digital landscape. Our team stays at the forefront of industry trends and innovations,
                    continuously refining our methodologies to ensure that we provide you with the most up-to-date and
                    effective solutions. We are committed to your success and are dedicated to providing you with
                    exceptional service and support throughout your journey.
                  </p>
                  <p>
                    Take the first step towards unlocking the full potential of your e-commerce business. Contact us
                    today to discover how our expertise in SEO, web analytics, and Google Ads can drive sustainable
                    growth for your business. Visit our website to explore our{' '}
                    <NextLink
                      title={All.SEOPricing[0].title}
                      href={
                        '/' + All.SEOPricing[0].url + '/' + All.SEOPricing[0].title.toLowerCase().replace(/ /g, '-')
                      }
                    />{' '}
                    options, our{' '}
                    <NextLink
                      title={All.CRO[2].title}
                      href={'/' + All.CRO[0].url + '/' + All.CRO[0].title.toLowerCase().replace(/ /g, '-')}
                    />
                    , learn more about the world of SEO, and see firsthand the transformative impact our analytics
                    services can have on your online presence. Trust SEOptimist, your{' '}
                    <NextLink title={All.HomeList[0].title} href={'/'} />, to be your strategic partner in achieving
                    your business goals and thriving in the digital landscape.
                  </p>
                </div>
              </div>
            </div>
          </section>
        </main>
        <ContactFooterCombo location="london" />
      </Fragment>
    </>
  );
};

export default croPage;
